import { useEffect, useState } from 'react';
import api from '../services/api';
import { getChecklist } from '../config/documentChecklists';

// items: [{ key, elementId }] → { [key]: { done, total } | null }
// A failed fetch (e.g. a role that can't see documents) gives null, not a false "0 uploaded".
export const useDocumentProgress = (items, refreshKey = 0) => {
  const [progress, setProgress] = useState({});
  const signature = items.map((i) => `${i.key}:${i.elementId}`).join('|');

  useEffect(() => {
    if (!signature) return undefined;
    let cancelled = false;
    Promise.all(items.map(async ({ key, elementId }) => {
      const checklist = getChecklist(elementId);
      try {
        const res = await api.get(`/core/documents/?element=${elementId}`);
        const uploaded = new Set(res.data.map((d) => d.doc_type));
        return [key, { done: checklist.filter((c) => uploaded.has(c)).length, total: checklist.length }];
      } catch {
        return [key, null];
      }
    })).then((entries) => { if (!cancelled) setProgress(Object.fromEntries(entries)); });
    return () => { cancelled = true; };
    // items is described fully by signature
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature, refreshKey]);

  return progress;
};
